// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2zYix","head":"ProcedureTableInfo_head__2mjTm"};